import type CreateProCheckoutResponse from '../types/CreateProCheckoutResponse';
import type ProResponse from '../types/ProResponse';
import type { SubscriptionUpgrade } from '../types/Subscription';
import buildCheckoutSessionId from './buildCheckoutSessionId';
import completeCheckoutSessionSubscriptionUpgrade from './completeCheckoutSessionSubscriptionUpgrade';
import createSubscriptionUpgrade from './createSubscriptionUpgrade';
import isThreeDSecureResponse from './isThreeDSecureResponse';
import type { ThreeDSecureAnalyticsInfo } from './runThreeDSecureFlow';
import runThreeDSecureFlow from './runThreeDSecureFlow';

type PerformSubscriptionUpgradeArgs = {
  analyticsInfo: ThreeDSecureAnalyticsInfo;
  body: SubscriptionUpgrade;
  container: HTMLElement;
  onThreeDSEnd: () => void;
  onThreeDSStart: () => void;
};

export default async function performSubscriptionUpgrade({
  analyticsInfo,
  body,
  container,
  onThreeDSEnd,
  onThreeDSStart
}: PerformSubscriptionUpgradeArgs): Promise<ProResponse> {
  const checkoutSessionId = buildCheckoutSessionId();

  const response = (await createSubscriptionUpgrade({
    ...body,
    checkout_session_id: checkoutSessionId
  })) as CreateProCheckoutResponse;

  if (!isThreeDSecureResponse(response)) {
    return response;
  }

  return runThreeDSecureFlow({
    actionTokenId: response.three_d_secure_action_token_id,
    analyticsInfo,
    checkoutSessionId,
    completeCheckoutSession: threeDSecureActionResultTokenId =>
      completeCheckoutSessionSubscriptionUpgrade({ checkoutSessionId, threeDSecureActionResultTokenId }),
    container,
    onThreeDSEnd,
    onThreeDSStart
  });
}
